// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbedEditor__root--1pX0i"};